import type { PaginationProps } from 'modules/types'
import type { TradeInHistory } from 'modules/tradein/trade-in.dto'
import CONSTANT from 'modules/constant'
import { API, download, headers } from './api'

export const tradeInApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getTradeInList: builder.mutation<PaginationProps<TradeInHistory>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_TRADE_IN_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    downloadTradeInList: builder.mutation<PaginationProps<TradeInHistory>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_TRADE_IN_DOWNLOAD,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData,
        responseHandler: download,
        formData: true
      })
    })
  })
})

export const { useGetTradeInListMutation, useDownloadTradeInListMutation } = tradeInApi
